import type { CSSProperties } from 'react';
import { TILE_SIZE, tileRect, type TileId } from '../game/assets/sheets';

/** CSS background for one tile of a sprite sheet at an integer scale. */
export function spriteStyle(tile: TileId, scale: number): CSSProperties | null {
  const rect = tileRect(tile);
  if (!rect) return null;
  const { sheet, sx, sy } = rect;
  const step = TILE_SIZE + sheet.margin;
  const sheetW = sheet.columns * step - sheet.margin;
  const sheetH = sheet.rows * step - sheet.margin;
  return {
    width: TILE_SIZE * scale,
    height: TILE_SIZE * scale,
    backgroundImage: `url(/${sheet.url})`,
    backgroundPosition: `${-sx * scale}px ${-sy * scale}px`,
    backgroundSize: `${sheetW * scale}px ${sheetH * scale}px`,
  };
}
